/**
 * Constantes dos Ramos de Atividade
 */
export interface ActivitySegment {
  value: string;
  labelKey: string;
}

export const ACTIVITY_SEGMENT: ActivitySegment[] = [
  { value: 'A', labelKey: 'pages.partnerForm.activitySegments.A' },
  { value: 'B', labelKey: 'pages.partnerForm.activitySegments.B' },
  { value: 'C', labelKey: 'pages.partnerForm.activitySegments.C' },
  { value: 'D', labelKey: 'pages.partnerForm.activitySegments.D' },
  { value: 'E', labelKey: 'pages.partnerForm.activitySegments.E' },
  { value: 'F', labelKey: 'pages.partnerForm.activitySegments.F' },
  { value: 'G', labelKey: 'pages.partnerForm.activitySegments.G' },
  { value: 'H', labelKey: 'pages.partnerForm.activitySegments.H' },
  { value: 'I', labelKey: 'pages.partnerForm.activitySegments.I' },
  { value: 'J', labelKey: 'pages.partnerForm.activitySegments.J' },
  { value: 'K', labelKey: 'pages.partnerForm.activitySegments.K' },
  { value: 'L', labelKey: 'pages.partnerForm.activitySegments.L' },
  { value: 'M', labelKey: 'pages.partnerForm.activitySegments.M' },
  { value: 'N', labelKey: 'pages.partnerForm.activitySegments.N' },
  { value: 'O', labelKey: 'pages.partnerForm.activitySegments.O' },
  { value: 'P', labelKey: 'pages.partnerForm.activitySegments.P' },
  { value: 'Q', labelKey: 'pages.partnerForm.activitySegments.Q' },
  { value: 'R', labelKey: 'pages.partnerForm.activitySegments.R' },
  { value: 'S', labelKey: 'pages.partnerForm.activitySegments.S' },
  { value: 'T', labelKey: 'pages.partnerForm.activitySegments.T' },
  { value: 'U', labelKey: 'pages.partnerForm.activitySegments.U' },
];
